import {
  between,
  required,
} from 'vuelidate/lib/validators';

const isTrue = param => param;
const isFalse = param => !param;

const fieldsToValidate = [
  {
    filter: 'reportsFilter',
    field: 'companies',
    label: 'header.company',
  },
  {
    filter: 'reportsFilter',
    field: 'installations',
    label: 'header.installation',
  },
  {
    filter: 'reportsFilter',
    field: 'assets',
    label: 'header.asset',
  },
  {
    filter: 'reportsFilter',
    field: 'sensors',
    label: 'header.sensor',
  },
  {
    filter: 'selectedFilter',
    field: 'moduleStatus',
    label: 'reports.network-status.fields.module-status',
  },
  {
    filter: 'selectedFilter',
    field: 'networkStatus',
    label: 'reports.network-status.fields.network-status',
  },
  {
    filter: 'selectedFilter',
    field: 'moduleSelfDiagnosisStatuss',
    label: 'reports.network-status.fields.module-self-diagnosis-status',
  },
  {
    filter: 'selectedFilter',
    field: 'address',
    label: 'reports.network-status.fields.address',
  },
  {
    field: 'ipIsValid',
    label: 'reports.network-status.fields.ip',
  },
  {
    field: 'periodInvalid',
    label: 'header.period',
  },
];

const validationsFields = {
  address: {
    minValue: 0,
    maxValue: 999999,
    maxLength: 6,
    precision: 0,
  },
};

const validations = {
  ipIsValid: {
    isTrue,
  },
  periodInvalid: {
    isFalse,
  },
  reportsFilter: {
    companies: {
      required,
    },
    installations: {
      required,
    },
    assets: {
      required,
    },
    sensors: {
      required,
    },
  },
  selectedFilter: {
    networkStatus: {
      required,
    },
    moduleStatus: {
      required,
    },
    moduleSelfDiagnosisStatuss: {
      required,
    },
    address: {
      between: between(validationsFields.address.minValue, validationsFields.address.maxValue),
    },
  },
};

export {
  fieldsToValidate,
  validationsFields,
  validations,
};
